import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center font-medium transition-colors",
  {
    variants: {
      variant: {
        default: "bg-purple-50 text-purple-600 border border-purple-100",
        pill: "bg-gray-50 text-gray-500 border border-gray-100",
        dark: "bg-gray-900 text-white border border-gray-800",
        accent: "bg-purple-600 text-white border border-purple-600",
        outline: "bg-transparent border border-white/[0.08] text-white/50",
        subtle: "bg-white text-gray-700 border border-gray-100 shadow-sm",
      },
      size: {
        sm: "px-2.5 py-0.5 text-[11px] rounded-full",
        default: "px-3 py-1 text-xs rounded-full",
        lg: "px-4 py-2 text-xs rounded-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, size, ...props }, ref) => (
    <span ref={ref} className={cn(badgeVariants({ variant, size, className }))} {...props} />
  )
)
Badge.displayName = "Badge"

export { Badge, badgeVariants }
